// extracted by mini-css-extract-plugin
module.exports = {"brandImage":"ProductBrandAccordion_brandImage__4qSBB","productBrand":"ProductBrandAccordion_productBrand__ylSIS","accordionTitle":"ProductBrandAccordion_accordionTitle__Nszoo"};